module.exports = __webpack_public_path__ + "img/sv.87a195b.svg";